module.exports = __webpack_public_path__ + "static/media/man-woman-full.796608c9.png";